import { useModeStore } from '../state/mode.store';

/**
 * ModeBadge - visual indicator for HC1 mode.
 *
 * LIVE = amber, DEMO = green per master prompt v3.3 §HC1 spec.
 * Click toggles. When the @scripsteam/scrips-signal-ds package publishes a
 * canonical Badge, swap this body for `<Badge variant={...} />` from the DS.
 */
export function ModeBadge() {
  const mode = useModeStore((s) => s.mode);
  const toggle = useModeStore((s) => s.toggle);

  const isLive = mode === 'live';
  const palette = isLive
    ? 'bg-mode-live-bg text-mode-live-fg ring-mode-live'
    : 'bg-mode-demo-bg text-mode-demo-fg ring-mode-demo';

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={`Mode: ${mode}. Click to toggle.`}
      className={`inline-flex items-center gap-2 rounded-signal-pill px-gutter-md py-1.5 text-signal-sm font-semibold ring-1 ring-inset ${palette} transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2`}
    >
      <span
        aria-hidden="true"
        className={`inline-block h-2 w-2 rounded-signal-pill ${isLive ? 'bg-mode-live' : 'bg-mode-demo'}`}
      />
      {mode.toUpperCase()}
    </button>
  );
}
